import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import CloudOff from '../../assets/cloud-off-solid.svg';

export function ErrorFallback() {
  const errorTitle = 'Si è verificato un errore';
  const errorMessage =
    'Ci scusiamo per il disagio! ' +
    'Siamo continuamente al lavoro per correggere errori come questo.';
  return (
    <Center>
      <CloudOff />
      <Title>Oops! {errorTitle}</Title>
      <p>{errorMessage}</p>
      <A to="/">Torna indietro</A>
    </Center>
  );
}

const Center = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: var(--space-4);
  & svg {
    width: 5rem;
    height: 5rem;
    fill: var(--primary);
    margin-bottom: var(--space-2);
  }
`;

const Title = styled.h2`
  margin-top: var(--space-3);
  margin-bottom: var(--space-2);
`;

const A = styled(Link)`
  display: flex;
  align-items: center;
  border-radius: 8px;
  min-height: 44px;
  margin-top: var(--space-2);
  padding: 0 var(--space-1);
  font-weight: 500;
  color: var(--text);
  &:hover,
  :focus {
    color: var(--primary-active);
    background-color: var(--on-primary);
  }
`;
